import { API } from "@/constants";
import { get } from "./api";

export interface SupportServiceStatus {
  serviceId: string;
  name: string;
  effectiveStatus: string;
  source?: string;
}

export interface SupportBannerStatusResponse {
  globalStatus: string;
  message: string;
  services: SupportServiceStatus[];
  computedAt: string;
}

export const getSupportBannerStatus = async (): Promise<SupportBannerStatusResponse> => {
  return await get<SupportBannerStatusResponse>(API.SUPPORT.BANNER_STATUS, {
    skipGlobalErrorHandler: true,
  });
};
